import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '@maximizer/core/shared/data-access';

@Pipe({ name: 'numberFormat', })
export class NumberFormatPipe implements PipeTransform {
  constructor(private readonly locale: LocaleService) {}

  transform(value?: number | string | null, format?: string): string {
    if (typeof value === 'string') {
      value = parseFloat(value);
    }

    return this.locale.formatNumber(value, format);
  }
}
